import axios from 'axios';
import appConfig from '../config/client';

axios.defaults.baseURL = appConfig.apiServicesUrl;
//axios.defaults.baseURL = 'http://localhost:8080';

export const adminUsersAdd = (searchUrlCode) => {
  let listUrl = '/admin/users/add';
  return axios.get(listUrl);
};

export const youtubeGetInfoByPlaylist = (id) => {
  //let listUrl = '/youtube/playlist-items?id=PL9f8_QifuTL4CS8-OyA-4WADhkddOnRS4';
  let listUrl = '/youtube/playlist-items/' + id;
  return axios.get(listUrl);
};

export const youtubeGetPlaylistsByChannel = (id) => {
  //let listUrl = '/youtube/playlists/?id=UCQCaS3atWyNHEy5PkDXdpNg';
  let listUrl = '/youtube/playlists/?id=' + id;
  return axios.get(listUrl);
};

export const youtubeGetChannelSummary = (id) => {
  let listUrl = '/youtube/channel-summary/' + id;
  return axios.get(listUrl);
};



// WEBPACK FOOTER //
// ./src/services/apiRequests.js